import {
  GetMedicalHistoryRequestProto,
  GetMedicalHistoryResponseProto,
} from "@noom/noom-contracts/noom_contracts/healthcare/service/healthcare/external_health_records_service";
import { Api } from "@noom/noomscape";

import axios, { AxiosResponse } from "axios";

Api.register(
  "healthRecords.getMedicalHistory",
  async ({
    accessCode,
    accessToken,
  }: GetMedicalHistoryRequestProto & { accessToken: string }) => {
    const response: AxiosResponse<GetMedicalHistoryResponseProto> = await axios(
      {
        baseURL: window.ENV.HEALTHCARE_SERVER_URL,
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
        method: "GET",
        url: `/externalHealthData/${accessCode}/medicalHistory`,
        urlWithPathParams: "/externalHealthData/{accessCode}/medicalHistory",
      },
    );

    return response.data;
  },
);
